import React, { useState } from 'react';

const ChangePasswordPopupHOC = (Component:any) => 
function Comp(props:any){
    const [showChangePasswordPopup,setShowChangePasswordPopup] = useState<boolean>(false);

    const changePasswordPopupToggleHandler = () => {
        setShowChangePasswordPopup(!showChangePasswordPopup);
    }
	
	return <Component showChangePasswordPopup={showChangePasswordPopup} changePasswordPopupToggleHandler={changePasswordPopupToggleHandler} {...props}/>;
};

export default ChangePasswordPopupHOC;   